<template>
	<FormTitle
		:text="title"
		:required="required"
		:disabled="disabled"
		:kizuna-type="kizunaType"
	/>

	<div class="flex flex-wrap">
		<div v-for="(item, index) in checkboxItem" class="checkbox" :key="index">
			<input
				type="checkbox"
				:value="index"
				:id="name + index"
				v-model="checkedItems"
			/>
			<label :for="name + index">{{ item }}</label>
		</div>
	</div>
	<ErrorText :text="errorText" />
</template>

<script setup>
import ErrorText from "@/components/atoms/ErrorText.vue";
import FormTitle from "@/components/atoms/FormTitle.vue";
import { computed, defineEmits, defineProps } from "vue";

/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["update:modelValue"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	modelValue: [String, Array],
	checkboxItem: [String, Object],
	title: String,
	name: String,
	disabled: Boolean,
	required: Boolean,
	errorText: String,
	copyFlag: Boolean,
	kizunaType: Number
});
/* ---------------------------------------------------------------------------
computed
---------------------------------------------------------------------------- */
const checkedItems = computed({
	get: () => {
		return props.modelValue;
	},
	set: value => {
		emit("update:modelValue", value);
	}
});
</script>
<style scoped lang="scss">
@use "/resources/css/_adjust.scss" as *;
input[type="checkbox"] {
	display: none;
}
/*Checkboxes styles*/
.checkbox {
	margin-right: 20px;
	&:last-child {
		margin-right: 0;
	}
}
.checkbox input[type="checkbox"] {
	display: none;
}
.checkbox input[type="checkbox"] + label {
	display: block;
	font-weight: bold;
	position: relative;
	padding-left: 30px;
	margin-bottom: 20px;
	font-family:
		14px/20px "Open Sans",
		Arial,
		sans-serif;
	color: rgba(51, 51, 51, 0.3);
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
}
.checkbox input[type="checkbox"] + label:last-child {
	margin-bottom: 0;
}
.checkbox input[type="checkbox"] + label:before {
	content: "";
	display: block;
	width: 20px;
	height: 20px;
	border: 2px solid $bg-green2;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0.6;
	-webkit-transition:
		all 0.12s,
		border-color 0.08s;
	transition:
		all 0.12s,
		border-color 0.08s;
}
.checkbox input[type="checkbox"]:checked + label:before {
	width: 10px;
	top: -3px;
	left: 5px;
	border-radius: 0;
	opacity: 1;
	border-top-color: transparent;
	border-left-color: transparent;
	-webkit-transform: rotate(45deg);
	transform: rotate(45deg);
}
.checkbox input[type="checkbox"]:checked + label {
	color: $color-green2;
	font-weight: bold;
}
</style>
